import { fromCalendarDate, toCalendarDate } from '../../shared/calendarDate';

export interface DateRange {
  from: string;
  to: string;
}

// The controller parses these YYYY-MM-DD values with Date.parse.
export const isoDate = toCalendarDate;
const parseIsoDate = fromCalendarDate;

const daysAgo = (days: number) => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date;
};

export const lastDays = (days: number): DateRange => ({ from: isoDate(daysAgo(days)), to: isoDate(new Date()) });

// The school year turns over with the June 30 reset, so it starts July 1.
export const schoolYear = (): DateRange => {
  const now = new Date();
  const startYear = now.getMonth() >= 6 ? now.getFullYear() : now.getFullYear() - 1;
  return { from: isoDate(new Date(startYear, 6, 1)), to: isoDate(now) };
};

export interface Preset {
  label: string;
  range: () => DateRange;
}

export const PRESETS: Preset[] = [
  { label: 'Last 30 days', range: () => lastDays(30) },
  { label: 'Last 90 days', range: () => lastDays(90) },
  { label: 'School year', range: schoolYear },
];

export const activePreset = (from: string, to: string) => PRESETS.find((preset) => {
  const range = preset.range();
  return range.from === from && range.to === to;
})?.label ?? null;

export const shortDate = (iso: string) => new Date(iso)
  .toLocaleDateString(undefined, { day: 'numeric', month: 'short' });

export const formatRange = (from: string, to: string) => {
  const start = parseIsoDate(from);
  const end = parseIsoDate(to);
  const sameYear = start.getFullYear() === end.getFullYear();
  const startText = start.toLocaleDateString(undefined, {
    day: 'numeric', month: 'short', ...(sameYear ? {} : { year: 'numeric' }),
  });
  const endText = end.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
  return `${startText} – ${endText}`;
};
